(function () {
    const lazyDivs = document.querySelectorAll('.lazy-bg');
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
        if(entry.isIntersecting) {
            const div = entry.target;
            const bg = div.getAttribute('data-bg');
            div.style.backgroundImage = `url('${bg}')`;
            observer.unobserve(div);
        }
        });
    });
    lazyDivs.forEach(div => observer.observe(div));
})();
